import { CreateUserTrialRequest } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const createUserTrial = (
  req: IndexSignature<CreateUserTrialRequest>
): Promise<unknown> =>
  request({
    url: '/service/userv2service/CreateUserTrial',
    body: req,
  }).then((r) => r.body);
